import ReviewOverlay from "@/components/base/ReviewOverlay";
import {breakpoints} from "@/styles/sizes";
import Image from "next/image";
import Link from "next/link";
import styled from "styled-components";
import ArrowDownGreenIcon from '/public/images/green_down.svg'
import {getColor} from "@/styles/ThemeConfig";
import Breadcrumbs from "@/components/other/Breadcrumbs";
import CustomDropdown from "@/components/other/CustomDropdown";
import {HeroCarousel} from "@/components/other/HeroCarousel";
import ForceSSRLink from "@/components/other/ForceSSRLink";

const SocialLink = styled.a`
    width: 40px;
    height: 40px;

    display: flex;
    justify-content:center;
    align-items:center;
    transition: 0.3s ease;

    :hover{
        background-color: rgba(0,0,0,0.05);
    }
`
const ContentWrapper = styled.div`
    width: 100%;
    height: 650px;
    background-image: url("${props => props.backgroundImageUrl}");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    position: relative;
    @media only screen and (${breakpoints.mobile}) {
        height: 450px;
    }
`;

const HeaderMobileWrapper = styled.div`
    padding:0 20px;
`;

const VideoWrapper = styled.div`
    height: 650px;
    @media only screen and (${breakpoints.mobile}) {
        height: 250px;
    }
`;




export default function CityHeroSection({reviewOverlayData, backgroundImageUrl, title, socialLinks,subtitle,breadcrumbds, scrollToDivRef, dropdownData, heroMedia, heroTitle}){

    const scrollToDiv = () => {
        scrollToDivRef?.current?.scrollIntoView({ behavior: 'smooth' });
    };

    // Most cities leave "Hero Title" blank in the CMS, which used to render an
    // empty <h1></h1> here while the real title sat in the <h2> below. The hero
    // overlay is only rendered when it has text, and the subtitle below is
    // promoted to h1 whenever the overlay is absent - so the page always has
    // exactly one, non-empty h1. Keeping className="h1" on both means the
    // computed styles are unchanged either way.
    const SubtitleTag = heroTitle ? 'h2' : 'h1';


    const heroIsVideo = [
        'video/mp4',     // MP4
        'video/webm',    // WebM
        'video/ogg',     // Ogg
        'video/quicktime', // MOV
        'video/x-msvideo', // AVI
        'video/x-ms-wmv',  // WMV
        'video/x-flv',   // FLV
        'video/mpeg',    // MPEG
        'video/3gpp',    // 3GPP
        'video/3gpp2',   // 3GPP2
        'video/x-matroska', // MKV
        'video/vnd.dlna.mpeg-tts', // DLNA MPEG-TS
        'application/vnd.apple.mpegurl', // HLS (M3U8)
        'video/x-m4v'    // M4V
    ].includes(heroMedia?.[0]?.mime);

    return (
        <div>
            <div className={'container_header'} style={{
                marginBottom: '25px',
            }}>
                <div style={{position: 'relative'}}>

                    <div className={'desktop_only'}>
                        <CustomDropdown items={dropdownData}/>
                    </div>


                    {heroTitle && <h1 style={{
                        zIndex:9,
                        position:'absolute',
                        left:'30px',
                        bottom:'250px',
                        font:'38px/50px Playfair Display',
                        color:'white',
                    }}>{heroTitle}</h1>}

                    <div style={{
                        position: "absolute",
                        left: '-50px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '10px',
                        marginBottom: '40px',
                    }}>
                        {socialLinks?.map((item, index) => {
                            return <SocialLink
                                key={index}
                                style={{}}
                                href={item?.url}
                                target={'_blank'}
                            >
                                <Image key={index} width={25} height={25} src={item?.darkImage?.url}
                                       alt={item?.darkImage?.alt ?? item?.darkImage?.name}
                                       style={{
                                           width: 'auto',
                                           height: 'auto',
                                       }}/>
                            </SocialLink>
                        })}
                    </div>


                    <div
                        onClick={scrollToDiv}
                        style={{
                            position: 'absolute',
                            left: '-35px',
                            bottom: 0,
                            "WebkitTransform": "rotate(180deg)",
                            "MozTransform": "rotate(180deg)",
                            "MsTransform": "rotate(180deg)",
                            "OTransform": "rotate(180deg)",
                            "transform": "rotate(180deg)",
                            "textTransform": "uppercase",
                            "letterSpacing": "1px",
                            "font": "14px JosefinSans-Regular",
                            "writingMode": "vertical-lr",
                            "display": "flex",
                            "alignItems": "center",
                            "textOrientation": "mixed",
                            "cursor": "pointer"
                        }}
                    >
                        <div style={{
                            color: getColor('lightGreen'),
                            display: 'flex',
                            alignItems: 'center',
                            gap: '30px',
                            lineHeight: 0,
                        }}>
                            <Image src={ArrowDownGreenIcon} alt={'Arrow Down'} style={{
                                transform: 'rotate(180deg)'
                            }}/>
                            SCROLL DOWN
                        </div>
                    </div>



                    {
                        heroIsVideo && (
                            <VideoWrapper>
                                {/* Review overlay for larger screens */}
                                <div className={'desktop_only'} style={{
                                    pointerEvents:'none',
                                    position: "absolute",
                                    width: "100%",
                                    bottom: '0',
                                    left: 0,
                                    zIndex: 3, // Ensure this is above everything else
                                }}>
                                    <ReviewOverlay data={reviewOverlayData} showMobile={false}/>
                                </div>
                                <video
                                    key={heroMedia?.[0]?.url}
                                    ref={(videoElement) => {
                                        if (videoElement) {
                                            setTimeout(() => {
                                                videoElement.play().catch((err) => {
                                                    console.error("Video play failed", err);
                                                });
                                            }, 500); // Delay autoplay by 500ms
                                        }
                                    }}
                                    loop
                                    muted
                                    playsInline
                                    preload="metadata"
                                    controls={true}
                                    poster={'/images/video_default_poster.jpg'}
                                    style={{
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                        zIndex: 1, // Ensure the video is in the background
                                    }}
                                >
                                    <source src={heroMedia?.[0]?.url} type={heroMedia?.[0]?.mime} />
                                    Your browser does not support the video tag.
                                </video>
                            </VideoWrapper>

                        )
                    }
                    {/* Overlay */}
                    <div
                        style={{
                            pointerEvents: 'none',
                            position: "absolute",
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            background: "linear-gradient(to bottom, rgba(0, 0, 0, 0.0) 46%, rgba(0, 0, 0, 0.22) 58%, rgba(0, 0, 0, 0.45) 100%)",
                            zIndex: 1, // Ensure the overlay sits above the content
                        }}
                    />

                    {!heroIsVideo && <HeroCarousel
                            images={heroMedia}
                        >
                            {/* Review overlay for larger screens */}
                            <div className={'desktop_only'} style={{
                                pointerEvents:'none',
                                position: "absolute",
                                width: "100%",
                                bottom: '0',
                                left: 0,
                                zIndex: 3, // Ensure this is above everything else
                            }}>
                                <ReviewOverlay data={reviewOverlayData} showMobile={false}/>
                            </div>
                        </HeroCarousel>
                    }



                    {/* Review overlay for mobile */}
                    <div className={'mobile_only'} style={{zIndex: 10}}> {/* Ensure this is above everything else */}
                        <ReviewOverlay data={reviewOverlayData} showMobile={false}/>
                    </div>
                </div>

                <div className={'container_small'}>
                    <HeaderMobileWrapper>
                        <SubtitleTag className={'h1'} style={{
                            fontFamily: "system-ui",
                            fontWeight: 400,
                            marginTop: '30px',
                            marginBottom: '20px',
                        }}>{subtitle}</SubtitleTag>

                        <Breadcrumbs items={breadcrumbds}/>
                    </HeaderMobileWrapper>

                </div>
            </div>
        </div>


    );

}
